import { combineSx } from '@chronosphereio/chrono-ui';
import { cloneElement, memo } from 'react';
import { LegendMode } from '@/core';
import { LegendItem } from './legend-model';

export const LEGEND_ICON_SIZE = 16;

export interface LegendIconProps extends Pick<LegendItem, 'icon'> {
  mode: LegendMode;
}

export const LegendIcon = memo(function LegendIcon({ icon, mode }: LegendIconProps) {
  if (!icon) {
    return null;
  }

  return cloneElement(icon, {
    sx: combineSx(icon.props.sx, {
      width: LEGEND_ICON_SIZE,
      height: LEGEND_ICON_SIZE,
      // When in list mode, add a little right margin to even out the spacing with the
      // checkbox.
      marginRight: mode === 'List' ? (theme) => theme.spacing(0.25) : undefined,
    }),
  });
});
